export default __webpack_public_path__ + "5a22da707876be7bd115a5f43cb536ae.png";